import { useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useParams } from "react-router-dom";
import testData from "../../testData.json"; // Assuming testData is in the same directory
import AddConvictions from "./addConvictions"
import DelConvliction  from "./delConvictions";
import UpdateConviction from "./updateConviction.js";
//import PostUnlinkWithdrawals from "./postUnlinkwithdrawals.js"
//import PostLinkWithdrawals from "./postLinkedWithdrawlas.js";
import { useEffect } from "react";
import Loading from "../tabs/loading";
import EditDriver from "./EditDriver";
//import NewMxDriver from "./newMxDriver";
import NoDriverConviction from "./noDriverConviction.js";
//import { basePage, baseUrl } from "../consts/baseUrl";
import NegateWithdrawal from "./negateWithdrawal";
import moment, { invalid } from "moment";
import { buildLinkConvictionsToWithdrawal, buildNegateConviction, 
        buildNegateWithdrawal, defaultConvictions, defaultDriverData, 
        defaultWithdrawals, dobMatch, errMessage, fcwdOnly, foreignData, 
        fromConvictionReview, generateData, isCDLHolder, makeLicense,
        makePersonDetails, postJson, setCDLHolder, setDefaultConvictions, 
        setDefaultDriverData, setDefaultWithdrawals, setErr, setFcwdOnly, setForeignData, setLinkedConvictions, setNewUser } from "../../utils/data.jsx";
import { useAuth } from "../../context/AuthContext.js";
import { ListGroup } from "react-bootstrap";
import { CAMessages, MXMessages } from "../../utils/messages.jsx";
import { canadianProvinces, countryOptions } from "../../utils/countryOptions.js";
//import { response } from "express";


 function DriverDetails() {
  const {source, token, userState, email, roles} = useAuth();
  const [tableData, setTableData] = useState([]);
  const { jurisdiction, license, lastname, firstname, dob, fcOnly } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [displayError, setDisplayError] = useState(false);
  const [country, setCountry] = useState(countryOptions["US"].find(c => c.code === jurisdiction) ? 
      "US-T" : countryOptions["OTH"].find(c => c.code === jurisdiction) ? 
      "OTH" : jurisdiction === 'MX' ? 'MX' : canadianProvinces.find(p => p.code === jurisdiction) ? "CA" : "");
  const [selectedConvictions, setSelectedConvictions] = useState([]);
  //const [trackConvictions, setTrackConvictions] = useState([]);
  const [stagedWithdrawals, setStagedWithdrawals] = useState([]);
  const [selectedWithdrawals, setSelectedWithdrawals] = useState([]);
  const [selectedStageWithdrawals, setSelectedStageWithdrawals] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [deleteType, setDeleteType] = useState("");
  const [userExists, setUserExists] = useState(true);
  const [loading, setLoading] = useState(true);
  const [editDriver, setEditDriver] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [requestIssue, setRequestIssue] = useState("");
  const [showButtons, setShowButtons] = useState(true);
  const [helpDesk, setHelpDesk] = useState();
  const [showPartial, setShowPartial] = useState(false);
  const [lastName, setLastName] = useState(lastname);
  const [firstName, setFirstName] = useState(firstname);
  const [validated, setValidated] = useState(false);
  const [CADob, setCADob] = useState(dob);
  const navigate = useNavigate();
  const screenRef = useRef(null);
  const driverRef = useRef(null);
  const errRef = useRef(null);
  let message = '';
  let sorMatch = false;
  let fcwdMatch = false;
  let partialMatch = [];
  let cdl = false;
  let timeout = false;

  const defined = (v) => v !== undefined && v !== null && v !== "";
  const negateDropDown = {'OR':['Court Ordered Negate', 'Administrative Negate', 'Other '], 'MI':['Court removal', 'Departmental removal']}
  const ENDPOINTS = {
    details: '/api/details',
    status: '/api/status',
    fcwdStatus: '/api/fcwd-only',
    negateConviction: '/api/conviction/delete',
    negateWithdrawal: '/api/withdrawal/negate',
    linkConvictions: '/api/withdrawal/links/add',
    removeAllLinks: '/api/withdrawal/delete/link'
  }
  const dataSource = {DataSource: source, CAorMXDown: 'no', userId: email}
  //const addedConvictions = []
  let help = "StateUI";
  if(defined(roles)){
    if(roles.includes("fcwdHelpDesk")){help = "HelpDesk"}
  }

  const formData = {
    "Header": {
        "Metadata": {
            "UserID": email
        }
    },
    "Body": {
        "Source":{
            DataSource: source
        },
        "License": {
          JurisdictionOfIssue: jurisdiction,
          LicenseNumber: license
        }
    }
  }

  const convertDate = (d) => {
  if (!defined(d)) return undefined;
  // If already "YYYYMMDD", return as-is:
  if (typeof d === "string" && /^\d{8}$/.test(d)) return d;
  try {
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}${m}${day}`;
  } catch {
    return undefined;
  }
};

  useEffect(() => {
      const temp = fcOnly;
      if(temp === 'true'){
        setFcwdOnly(true)
      }
    },[]
  )
  
  useEffect(() => {

    if (!source || !email) return;
    const fetchData = async () => {

    try {
      setNewUser(false);
      await postJson(ENDPOINTS.details, formData, null, token)
      .then(async function(result){
        setTableData(result ?? []);
        setDefaultDriverData(result ?? []);
        fcwdMatch = defaultDriverData?.driverLicense ? true : false;
        setCADob(dob ? moment(dob).format("YYYY-MM-DD") : moment(result.PersonDetails.DOB).format("YYYY-MM-DD"));
        const data = buildStatusRequest(`FCWD.${source[0]}-${email}`, jurisdiction, country, license, lastname, firstname, dob, result);
        if(!data){
          if((country === 'CA')){
            setDefaultDriverData({
              PersonDetails:{
                PersonName:{SurName:lastname, FirstName:firstname},
                DOB: dob,
              },
              License:{JurisdictionOfIssue: jurisdiction, LicenseNumber: license}
            });
          } else{
            setDefaultDriverData({License:{JurisdictionOfIssue: jurisdiction, LicenseNumber: license}})
          }
          setNewUser(result.License.LicenseNumber === null ? true: false);
          setUserExists(false);
          setEditDriver(true);
          setLoading(false);
          return;
        } else{ 
          let endpoint = fcwdOnly ? ENDPOINTS.fcwdStatus : ENDPOINTS.status;
          await postJson(endpoint, data, null, token)
          .then(function(statusResult){
            if(statusResult === -1){
              setErr(<div style={{color:'red'}}>Internal Data Error</div>)
              if(roles.includes('fcwdHelpDesk')){
                setEditDriver(true)
              }
              return;
            }
            if(statusResult.Messages.includes("Transaction processing exceeded maximum time") || 
            statusResult.Messages.includes("Canada is Currently Unavailable") ||
            statusResult.Messages.includes("Mexico eLicencia is Currently Unavailable")){
              timeout = true;
              setEditDriver(true);
              setLoading(false);
                              // message = jurisdiction === 'MX' ? 
              // "Mexican Driver License Database is Unavailable or Down. If CDL = Yes, add to FCWD. If CDL = No, wait until a valid response is received." :
              // "Canadian Providence Database is Unavailable or Down. CDL Holder cannot be determined. If CMV = Yes, add to FCWD. If CMV = No, wait until a valid response is received.";
            }
            if(statusResult.Messages.includes("REQUESTED RECORD NOT FOUND")){ 
                setEditDriver(true);
              }
            if(statusResult.Response.DriverDetails !== undefined) {
              if(country === 'CA'){
                if (statusResult.Response.DriverDetails?.Confirmations) {
                  const confirmations = statusResult.Response.DriverDetails.Confirmations;
                  const licenseNumber = confirmations.DriverLicense?.LicenseNumber;
                  // Check if license number is INVALID
                  if (licenseNumber === "INVALID") {
                    partialMatch = [];
                    sorMatch = false;
                    setEditDriver(true)
                  }
                  else{
                    // Check if any other field is INVALID
                    partialMatch = generateData(confirmations);
                    sorMatch = partialMatch.length === 0;
                    setShowPartial(partialMatch.length > 0);
                  }
                } 
                // else {
                //   message = fcwdOnly && !fcwdMatch ? "" : "Canadian Providence Database is Unavailable or Down. CDL Holder cannot be determined. If CMV = Yes, add to FCWD. If CMV = No, wait until a valid response is received.";
                //   setEditDriver(true);
                // }
              }
              setTableData(statusResult.Response.DriverDetails || []);
              setForeignData(statusResult.Response.DriverDetails || [], statusResult.RequestKey.Body.DriverRequest || []);
              // setDefaultDriverData(statusResult.Response.DriverDetails || []);
              setHelpDesk(source === 'HelpDesk' ? statusResult.Response.DriverDetails : []);
              setDefaultConvictions(statusResult?.Response?.DriverDetails?.Convictions || []);
              setDefaultWithdrawals(statusResult?.Response?.DriverDetails?.Withdrawals || []);
              setStagedWithdrawals(statusResult?.Response?.DriverDetails?.StgWithdrawals || []);
              const license = statusResult?.Response?.DriverDetails?.License;
              cdl = license && ["A", "B", "C", "BA"].includes(license?.CommercialClassCode?.toUpperCase());
              console.log('CDL value: ', cdl, license?.CommercialClassCode)
              setCDLHolder(cdl);
            } else {
              setNewUser(fcwdMatch ? false : true);
              setUserExists(fcwdMatch ? true : false);
            }
            if(defaultDriverData?.surName === "" && foreignData.surName === ""){
                setEditDriver(true);
            }
              if(country !== 'CA' && message === ''){message = MXMessages(country, fcwdMatch, statusResult.Messages, cdl, timeout)}
              if(country === 'CA' && message === ''){message = CAMessages(cdl, sorMatch, fcwdMatch, partialMatch, timeout);}
              if(!sorMatch && message.includes("Driver is not a CDL Holder")){
                if(country === 'CA'){
                  setDefaultDriverData({
                    PersonDetails:{
                      PersonName:{SurName:lastname, FirstName:firstname},
                      DOB: dob,
                    },
                    License:{JurisdictionOfIssue: jurisdiction, LicenseNumber: license}
                  });
                } else{
                  setDefaultDriverData({License:{JurisdictionOfIssue: jurisdiction, LicenseNumber: license}})
                }
                setNewUser(true);
                setUserExists(false);
                setEditDriver(true);
                setLoading(false);
              }
              if(sorMatch){setEditDriver(false)}
              if(message.includes('Conviction/Withdrawal cannot be added')){
                setShowButtons(false);
              }
              if(message.includes("Driver is a CDL Holder") || (message.includes("Data is from FCWD. If CMV = Yes, add to FCWD.") && !message.includes("Unavailable"))){
                setErr(<span>{message}</span>)
              } else{
                if(message !== ''){
                  setErr(<span style={{color:'red'}}>{message}</span>)
                }
              }
              if(message.includes("Data is from FCWD. If CMV = Yes, add to FCWD. If CMV = No, do not add to")){
                setEditDriver(true)
              }
          })
          .catch(function(error){
            const msg =
              error?.response?.data?.details ||   // your backend's helpful message
              error?.response?.data?.error ||     // fallback
              error?.message ||                   // axios message
              String(error);

            setErr(<span style={{ color: "red" }}>Error fetching driver status: {msg}</span>);
            if(msg.includes("HTTP 400:")){
              setErr(<span style={{ color: "red" }}>Requested Record Not Found</span>)
            }
            setNewUser(true);
            setUserExists(false);
            setLoading(false);
          });
        }
        /*
        if(defined(foreignData.dob)){
          setEditDriver(false)
        }
        */
      })
      .catch(function(error){
        const msg =
          error?.response?.data?.details ||   // your backend's helpful message
          error?.response?.data?.error ||     // fallback
          error?.message ||                   // axios message
          String(error);

        setErr(<span style={{ color: "red" }}>Error fetching driver status: {msg}</span>);
        setNewUser(true);
        setUserExists(false);
        setLoading(false);
      });
    } catch (error) {
        const msg =
          error?.response?.data?.details ||   // your backend's helpful message
          error?.response?.data?.error ||     // fallback
          error?.message ||                   // axios message
          String(error);

        setErr(<span style={{ color: "red" }}>Error fetching driver status: {msg}</span>);
        setNewUser(true);
        setUserExists(false);
        setLoading(false);
    }

    
    setLoading(false);
  };
  fetchData();
  }, [jurisdiction, license, source]);
      // const testNull = JSON.stringify({"firstName":"","middleName":"","surName":"","suffix":"","dob":"","street1":"","street2":"","city":"","county":"","state":"","zip":"","country":"","driverState":"","driverLicense":"","sex":""})
      //     if(jurisdiction === "MX"){
      //       if(JSON.stringify(defaultDriverData) === testNull){
      //         if(JSON.stringify(foreignData) !== testNull){
      //           setErr("MX did not supply data, but driver is a CDL Holder. Add conviction to FCWD.")
      //         }
      //       }
      //     }

      //alert(JSON.stringify(defaultWithdrawals[0]))

      //alert(status)

const handleAddWithdrawal = (e) => {
  const {name} = e.target;
  setLinkedConvictions(selectedConvictions);
  navigate(`${name}`)
}

let Country = "";

//alert(JSON.stringify(defaultDriverData))

//alert(formData.dob + " : " + editDriver)
const handleRemoveLinks = () => {

  selectedWithdrawals.map(async (v,k) => {
    console.log(v, k);

    const req ={
    "Header": {
        "Metadata": {
            "UserID": email
        }
    },
    "Body": {
        "Source":{
            "DataSource": source
        },
        "License": {
            "JurisdictionOfIssue": jurisdiction,
            "LicenseNumber": license
        },
        "WithdrawalID": v
    }
  }


    await postJson(ENDPOINTS.removeAllLinks, req, null, token);

    let direct = "/driverdetails/"
      + jurisdiction + "/" + encodeURIComponent(license);
    window.location.replace(direct);

  })

}

console.log("Con: "+JSON.stringify(defaultConvictions[0]))
console.log("Wit: "+JSON.stringify(defaultWithdrawals[0]))

//console.log(JSON.stringify(defaultDriverData))
//alert(JSON.stringify(defaultDriverData))

const addLinks = async () => {
  console.log(selectedWithdrawals, selectedConvictions);

  const req = {
      "Header": {
          "Metadata": {
              "UserID": email
          }
      },
      "Body": {
          "Source":{
              "DataSource": source
          },
          "License": {
              "JurisdictionOfIssue": jurisdiction,
              "LicenseNumber": license
          },
          "WithdrawalID" : selectedWithdrawals[0],
          "ConvictionIds" : selectedConvictions.map(v => v)// At least one conviction Id is Required
      }
  }
  
  /*
  const req = {
    ...formData,
    WithdrawalID: selectedWithdrawals[0],
    ConvictionIds: selectedConvictions.map(v => v)
  }

  */
  await postJson(ENDPOINTS.linkConvictions, req, null, token);

  let direct = "/driverdetails/" + jurisdiction + "/" + encodeURIComponent(license);
  window.location.replace(direct);

}
  
  const handleDeleteClick = (type) => {

    if(!defined(token)){
      navigate('/login');
    }

    setDeleteType(type);
    setErrorMessage(`No ${type} have been selected. Please select the ${type} you wish to negate/delete.`);
    if (type === 'Conviction(s)'){
      if(selectedConvictions.length === 0) {
        setDisplayError(true);
        return;
      }
      if(selectedConvictions.length > 1) {
        setErrorMessage("Multiple Convictions have been selected. Please select only one Conviction you wish to negate/delete.")
        setDisplayError(true);
        return;
      }
    }
    if (type === 'Withdrawal(s)') {
      if(selectedWithdrawals.length === 0) {
        setDisplayError(true);
        return;
      }
      if(selectedWithdrawals.length > 1) {
        setErrorMessage("Multiple Withdrawals have been selected. Please select only one Withdrawal you wish to negate/delete.")
        setDisplayError(true);
        return;
      }
    }
    if(type === 'ConvictionReview') {
      setShowReviewModal(true);
      return;
    }
    
    setShowModal(true);
  };

  const checkSelection = (buttonType) => {
    if(buttonType === 'updateWithdrawal' ) {
      if((selectedWithdrawals.length === 0 || selectedWithdrawals.length > 1)){
        setErrorMessage("Please only select one withdrawal to update at once.");
        setDisplayError(true);
        return;
      }else {
        setDefaultWithdrawals(selectedWithdrawals);
        navigate('/updatewithdrawal');
      }
    }
    if(buttonType === 'updateStageWithdrawal') {
      if((selectedStageWithdrawals.length === 0 || selectedStageWithdrawals.length > 1)){
        setErrorMessage("Please only select one withdrawal to update at once.");
        setDisplayError(true);
        return;
      }else {
        setDefaultWithdrawals(selectedStageWithdrawals);
        navigate('/staging/updatewithdrawal');
      }
    }
    if(buttonType === 'updateConviction') {
      if((selectedConvictions.length === 0 || selectedConvictions.length > 1)){
        setErrorMessage("Please only select one conviction to update at once.");
        setDisplayError(true);
        return;
      } else{
        let acd = "";
        let cdl = "";
        let n = 0;
        defaultConvictions.map((v, i) => {
          if(v.ConvictionIdCode === selectedConvictions[0]){
            console.log("VV: "+JSON.stringify(v));
            acd = v.ConvictionOffenseAcdCode.Code;
            cdl = v.CitationCdlHolderIndicator[0];
            n = i;
          }
          if(!defined(cdl)){
            cdl = 9;
          }
        })
        const disable = cdl === "1" ? true : false;
        
        navigate("/updateconviction/"+jurisdiction+"/"+encodeURIComponent(license)+"/"+selectedConvictions
          +"/"+acd+"/"+cdl+"/"+disable+"/"+n);
      }
    }
    if(buttonType === 'linkConvictions') {
      if(!defined(token)){
        navigate('/login');
      }

      if(selectedWithdrawals.length === 0) {
        setErrorMessage("No Withdrawals have been selected. Please select the Withdrawal you wish to update.");
        setDisplayError(true);
        return;
      } else if(selectedWithdrawals.length > 1) {
        setErrorMessage("Please select only one Withdrawal at a time to link Conviction(s).");
        setDisplayError(true);
      }else if(selectedConvictions.length === 0) {
        setErrorMessage("No Convictions have been selected. Please select the Conviction(s) you wish to link.");
        setDisplayError(true);
        return;
      } else {
        addLinks();
        return;
      }
      
    }
    if(buttonType === 'removeAllLinks') {

    if(!defined(token)){
      navigate('/login');
    }

      if( selectedWithdrawals.length === 0){
        setErrorMessage("No Withdrawals have been selected. Please select the Withdrawal from which you want to remove the link(s).");
        setDisplayError(true);      
        return;
      }else {
        handleRemoveLinks();
      }
    } 
  }

  const convertDrvObject = (tableData) => {

  let useData = tableData;

  //alert(JSON.stringify(defaultDriverData.dob))

    let help = false; 
    if(helpDesk !== undefined) {
      help = true;
    }

  //  if(!defined(tableData?.PersonDetails?.DOB)){

  let tag = defaultDriverData.country;

  if((defaultDriverData.country === "Canada") || (defaultDriverData.country === "CA")){
    tag = "CA"
  }

  if((defaultDriverData.country === "Mexico") || (defaultDriverData.country === "MX")){
    tag = "MX"
  }

  if(defaultDriverData.country === "US"){
    tag = "US";
  }
      
     const driverData = {
      "firstName"     : defaultDriverData?.firstName,
      "middleName"    : defaultDriverData?.middleName,
      "surName"       : defaultDriverData?.surName,
      "suffix"        : useData?.PersonDetails?.PersonName?.Suffix,
      "dob"           : defaultDriverData?.dob.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3"),
      "street1"       : defaultDriverData?.street1,
      "street2"       : defaultDriverData?.street2,
      "city"          : defaultDriverData?.city,
      "county"        : defaultDriverData?.county,
      "state"         : defaultDriverData?.state,
      "zip"           : defaultDriverData?.zip,
      "country"       : defaultDriverData?.country,
      "driverState"   : jurisdiction,
      "driverLicense" : license,
      "sex"           : defaultDriverData?.sex, 
      "ssn"           : useData?.PersonDetails?.SSN,
      "help"          : help,
      "source"        : source,
      "email"         : email,
      "cntTag"        : tag
    };

    return driverData;
/*
    } 
    

    const driverData = {
      "firstName"     : useData?.PersonDetails?.PersonName?.FirstName,
      "middleName"    : useData?.PersonDetails?.PersonName?.MiddleName,
      "surName"       : useData?.PersonDetails?.PersonName?.SurName,
      "suffix"        : useData?.PersonDetails?.PersonName?.Suffix,
      "dob"           : useData?.PersonDetails?.DOB,
      "street1"       : useData?.PersonDetails?.MailingAddress?.Line1,
      "street2"       : useData?.PersonDetails?.MailingAddress?.Line2,
      "city"          : useData?.PersonDetails?.MailingAddress?.City,
      "county"        : useData?.PersonDetails?.MailingAddress?.County,
      "state"         : useData?.PersonDetails?.MailingAddress?.State,
      "zip"           : useData?.PersonDetails?.MailingAddress?.Zip,
      "country"       : tableData?.PersonDetails?.MailingAddress?.Country,
      "driverState"   : jurisdiction,
      "driverLicense" : license,
      "sex"           : useData?.PersonDetails?.PhysicalDetails?.Sex, 
      "ssn"           : useData?.PersonDetails?.SSN,
      "help"          : help,
      "source"        : source,
      "email"         : email
    };
    */
    //return driverData;
  }

  const handleInputChange = (e) => {
        setInputValue(e.target.value);
  }

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    
    if(!defined(token)){
      navigate('/login');
    }
    if (deleteType ===  'Conviction(s)'){
    
      const conviction = defaultConvictions.find((item) => item.ConvictionIdCode === selectedConvictions[0]) || null;
      conviction.ConvictionUserID = email;
      await postJson(ENDPOINTS.negateConviction, buildNegateConviction({ conviction: conviction, comment: inputValue, sourceOpts: dataSource }), null, token)
      .then(function(result) {
           if(result?.Messages?.includes("Conviction Deleted")) {
          navigate(0);
        } else{
          setRequestIssue(result?.Messages || "Issue Deleting Withdrawal. Contact Help Desk.");
        } 
      })
      .catch((error) => {
          console.error(error)
          setRequestIssue("Issue Deleting Conviction. Contact Help Desk.");
      })
    }
    if(deleteType === 'Withdrawal(s)'){
      let withdrawal = defaultWithdrawals.find((item) => item.DriverLicenseWithdrawalIdCode === selectedWithdrawals[0]) || null;
      withdrawal.WithdrawalUserId = email;
      await postJson(ENDPOINTS.negateWithdrawal, buildNegateWithdrawal({ withdrawal: withdrawal, comment: inputValue, sourceOpts: dataSource }), null, token)
      .then(function(result) {
        if(result?.Messages?.includes("Withdrawal Deleted")) {
          navigate(0);
        } else{
          setRequestIssue(result?.Messages || "Issue Deleting Withdrawal. Contact Help Desk.");
        }
      })
      .catch((error) => {
          console.error(error)
          setRequestIssue("Issue Deleting Withdrawal. Contact Help Desk.");
      })
}
  }

  if(loading) {
    return(
      <>
      <Loading />
      </>
    )
  }

  //alert(JSON.stringify(defaultWithdrawals))

  const handleReviewComplete = async () => {
    let requestBody = {
          "Header": {
            "Metadata": {
                "UserID": email //to be replaced with db email
            }
        },
        "Body": {
            "Source":{
                "DataSource": source,
            },
            "ReviewIds": null,
            "UserID": email
        }
    }
    await postJson('/api/reviews', requestBody, null, token)
    .then(async (response) => {
      const driverReviews = response.Records.filter(
        record => record.driver_license_number === license
      );
      requestBody.Body.ReviewIds = driverReviews.map(review => review.review_id);
      console.log("Request Body: ", requestBody);
      await postJson('/api/delete/reviews', requestBody, null, token);
      navigate('/');
    })
  }
  const handleNoDriverConviction = (e) =>{

    e.preventDefault();

    try {  
      ReactDOM.render(<NoDriverConviction jurisdiction={jurisdiction} license={license} />,
        screenRef.current); 
      } catch(err){
        alert(err)
      }
  }


  const handleEditDriver = (e) => {
    e.preventDefault();

    //console.log(JSON.stringify(tableData))

    //alert(JSON.stringify(defaultDriverData))
    //alert(JSON.stringify(tableData))

    const driverData = convertDrvObject(defaultDriverData);

    try {    
      ReactDOM.render(<EditDriver driverData={driverData} />,
        driverRef.current); 
      } catch(err){
        alert(err)
      }
  }

  const handlAddConvictions = (e, tableData) => {
    e.preventDefault();

    
    if(!defined(token)){
      navigate('/login');
    }
 /*   
    let help = "StatesUI"
    if(helpDesk !== undefined) {
      help =  "HelpDesk";
    }
*/

    console.log(JSON.stringify(defaultConvictions[0]))

    navigate("/addconviction/"+jurisdiction+"/"+encodeURIComponent(license)+"/"+help)

    /*
    
    if(editDriver){
       navigate("/noDriverConviction/"+jurisdiction+"/"+license)
    } else {
      navigate("/addconviction/"+jurisdiction+"/"+license+"/"+help)
    }
      */
  }

  
  if(!defined(foreignData.country) && defined(defaultDriverData)){
    Country = defaultDriverData.country;
  } else {
    Country = foreignData.country;
  }
  
  const handleSubmit = (e) => {
    e.preventDefault();
    //alert(dob)
      //validateDate(dob,true, val)
      //validateDate(dob,true, val)
    const form = e.target;
    if (form.checkValidity() === false) {
        e.stopPropagation(); // prevent submit if invalid
    } else {
      let returnedRecord = false;  
      e.preventDefault();
      let endpoint = `/canadadetails/${jurisdiction}/${encodeURIComponent(license)}/${lastName}`;
      if (firstName) {
          endpoint += `/${firstName}`;
      }
      endpoint += `/${CADob.replaceAll('-', '')}`;
      navigate(endpoint, { replace: true });
      navigate(0);
    }
    setValidated(true);
  }
  let gridFont = "";
    if(helpDesk === "HelpDesk"){
      gridFont = "x-small"
    }

  if(!userExists) {
    return (
      <div className="App"><h1>Driver Details Create User</h1>
        <div>{errMessage}</div>
      <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
      <div>
        <tr>
            <td className="col-md-3">Driver State</td>
            <td className="col-md-3">Driver License</td>
        </tr>
        <tr>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={jurisdiction} disabled /></td>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={license} disabled /></td>
        </tr>
        {country === 'CA' &&
        <><div className="row">
                <div className="col-md-2">
                  <label for="inputLastName" className="form-label"><b><span className="text-danger">*</span> Last Name</b></label>
                  <input className="form-control" type="text" name='DriverLastName'
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)} required />
                  <div className="invalid-feedback">Last Name Required</div>

                </div>
                <div className="col-md-2">
                  <label for="inputFirstName" className="form-label"><b>First Name</b></label>
                  <input type="text" className="form-control" name="DriverFirstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)} />
                </div>
                <div className="col-md-2">
                  <label for="inputDOB" className="form-label"><b><span className="text-danger">*</span> Date of Birth</b></label>

                  <input type="date" className="form-control"
                    placeholder="MM/DD/YYYY"
                    data-index="1" name='dob'
                    value={moment(CADob).format("YYYY-MM-DD")}
                    onChange={(e) => setCADob(e.target.value)}
                    min="1"
                    max={moment().format("YYYYMMDD")}
                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}'
                    required />
                  <div className="invalid-feedback">Please enter a valid Date of Birth</div>
                </div>
                {/* <small>*First Name is required to match the Canadian Record. If the driver has only one name or a period(.) as a first name, the field may be left blank.</small> */}
              </div><button type="submit" className="btn btn-primary" id="button">
                  Query Canada
                </button></>}
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} 
         onClick={() => navigate("/noDriverConviction/"+jurisdiction+"/"+encodeURIComponent(license))}
        //onClick={handleNoDriverConviction}
        >Create Conviction</button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} onClick={() => navigate("/addwithdrawal")}>Create Withdrawal</button>
      </div>
      </form>
      </div>
    );
  }

  return (
    <div className="App" ref={screenRef}>
      <h1>Driver Details</h1>
      <div>
        <div>{errMessage}</div>
        <div ref={errRef}></div>
        {showPartial ?
        <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
        <tr>
            <td className="col-md-3">Driver State</td>
            <td className="col-md-3">Driver License</td>
        </tr>
        <tr>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={jurisdiction} disabled /></td>
           <input class="form-control" type="text" placeholder={license} disabled />
        </tr>
        <div className="row">
        <div className="col-md-2">
            <label for="inputLastName" className="form-label"><b><span className="text-danger">*</span> Last Name</b></label>
            <input className="form-control" type="text" name='DriverLastName' 
            value={lastName}
            onChange={(e) => setLastName(e.target.value)} required/>
            <div className="invalid-feedback">Last Name Required</div>
            
        </div>
          <div className="col-md-2">
              <label for="inputFirstName" className="form-label"><b>First Name</b></label>
              <input type="text" className="form-control" name="DriverFirstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}/>
          </div>
            <div className="col-md-2">
              <label for="inputDOB" className="form-label"><b><span className="text-danger">*</span> Date of Birth</b></label>
              
                  <input type="date" className="form-control" 
                      placeholder="MM/DD/YYYY"
                      data-index="1"  name='dob'
                      value={moment(CADob).format("YYYY-MM-DD")}
                      onChange={(e) => setCADob(e.target.value)}
                      min="1"
                      max={moment().format("YYYY-MM-DD")}
                      pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                    required />
              <div className="invalid-feedback">Please enter a valid Date of Birth</div>
          </div>
          {/* <small>*First Name is required to match the Canadian Record. If the driver has only one name or a period(.) as a first name, the field may be left blank.</small> */}
      </div>
        <button type="submit" className="btn btn-primary" id="button">
          Query Canada
        </button>
      </form> :
      <><tr>
          <td className="col-md-3">Driver State</td>
          <td className="col-md-3">Driver License</td>
        </tr><tr>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={jurisdiction} disabled /></td>
            <input class="form-control" type="text" placeholder={license} disabled />
          </tr></>
      }

        <div ref={driverRef} >
          {editDriver &&
            <button type="button" className="btn btn-primary" 
            id="button" form='Index-form' style={{"textAlign": "start"}} 
            onClick={(e) => handleEditDriver(e)}
            >Edit</button>
          }
        <button type="button" className="btn btn-primary" 
          id="button" form='Index-form' style={{"textAlign": "start"}} 
          onClick={(e) => navigate('/')}
          >Close</button>

        {(fromConvictionReview && source === 'HelpDesk') &&
        <button type="button" className="btn btn-primary" 
          id="button" form='Index-form' style={{"textAlign": "start"}}
          onClick={() => handleDeleteClick('ConvictionReview')}
          disabled={!showButtons}
          >Review Complete</button>
        }
        <div className="accordion" id="table" style={{fontSize: 'medium'}}>
        <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">Driver General Information</h3>
        <table className="table table-striped table-bordered accordion-collapse collapse show"  id="panelsStayOpen-collapseOne">
        
        <thead style={{width: '100%'}}>
            <tr>
                <th scope="col">First Name</th>
                <th scope="col">Middle Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Suffix</th>
                <th scope="col">Date of Birth</th>
            </tr>
        </thead>
        <tbody>
          {foreignData.surName ?
            <tr>
                <td scope="col">{foreignData.firstName || firstname}</td>
                <td scope="col">{foreignData.middleName}</td>
                <td scope="col">{foreignData.surName || lastname}</td>
                <td scope="col">{foreignData.suffix}</td>
                <td scope="col">{foreignData.dob || dob}</td>
            </tr>
            :
            <tr>
                <td scope="col">{defaultDriverData.firstName || firstname}</td>
                <td scope="col">{defaultDriverData.middleName}</td>
                <td scope="col">{defaultDriverData.surName || lastname}</td>
                <td scope="col">{defaultDriverData.suffix}</td>
                <td scope="col">{defaultDriverData.dob || dob}</td>
            </tr>
          }
        </tbody>
        </table>
        <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true" aria-controls="panelsStayOpen-collapseTwo">Residence</h3>
        <table className="table table-striped table-bordered accordion-collapse collapse show"  id="panelsStayOpen-collapseTwo">
        
        <thead style={{width: '100%'}}>
            <tr>
            <th>Street Address1</th>
            <th>Street Address2</th>
            <th>City</th>
            <th>County</th>
            <th>State</th>
            <th>Zip code</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          {foreignData.surName ?
          <tr>
            <td>{foreignData.street1}</td>
            <td>{foreignData.street2}</td>
            <td>{foreignData.city}</td>
            <td>{foreignData.county}</td>
            <td>{foreignData.state}</td>
            <td>{foreignData.zip}</td>
            <td>{foreignData.country || defaultDriverData.country || jurisdiction}</td>
          </tr>
          :
          <tr>
            <td>{defaultDriverData.street1}</td>
            <td>{defaultDriverData.street2}</td>
            <td>{defaultDriverData.city}</td>
            <td>{defaultDriverData.county}</td>
            <td>{defaultDriverData.state}</td>
            <td>{defaultDriverData.zip}</td>
            <td>{defaultDriverData.country || jurisdiction}</td>
          </tr>
          }
        </tbody>
        </table>
        {(source === 'HelpDesk' && helpDesk) && <>
        <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="true" aria-controls="panelsStayOpen-collapseThree">Driver License Details</h3>
          <table className="table table-striped table-bordered accordion-collapse collapse show"  id="panelsStayOpen-collapseThree">
              <thead>
                  <tr>
                      <th scope="col">Issue Date</th>
                      <th scope="col">Expiration Date</th>
                      <th scope="col">Commercial Class</th>
                      <th scope="col">Commercial Status</th>
                      <th scope="col">Withdrawal Action Pending</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>{helpDesk?.License?.IssueDate}</td>
                      <td>{helpDesk?.License?.ExpirationDate}</td>
                      <td>{helpDesk?.License?.CommercialClassCode}</td>
                      {helpDesk?.License?.CommercialStatus.split('-')[1] ? <td>{helpDesk?.License?.CommercialStatus.split('-')[1]}</td> : <td>{helpDesk?.License?.CommercialStatus}</td>}
                      <td>{helpDesk?.License?.WithdrawalActionPending}</td>
                  </tr>
              </tbody>
          </table>
          {country === 'MX' && helpDesk?.MedicalCertificate && 
          <><h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true" aria-controls="panelsStayOpen-collapseFour">Medical Certifications</h3><table className="table table-striped table-bordered accordion-collapse collapse show" id="panelsStayOpen-collapseFour">
                  <thead>
                    <tr>
                      {country === 'MX' && <th>Medical Number</th>}
                      <th>Issue Date(YYYYMMDD)</th>
                      <th>Expiration Date(YYYYMMDD)</th>
                      <th>Status Code</th>
                      <th>Self Certification</th>
                    </tr>
              </thead>
                  <tbody>
                    <tr>
                      {country === 'MX' && <td>{helpDesk?.MedicalCertificate?.MedicalNumber}</td>}
                      <td>{helpDesk?.MedicalCertificate?.IssueDate}</td>
                      <td>{helpDesk?.MedicalCertificate?.ExpirationDate}</td>
                      <td>{helpDesk?.MedicalCertificate?.StatusCode?.split('-')[1] || tableData?.medCert?.StatusCode}</td>
                      <td>{helpDesk?.MedicalCertificate?.SelfCertificationCode || tableData?.medCert?.SelfCertification}</td>
                    </tr>
                  </tbody>
                </table></>
          }
            <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true" aria-controls="panelsStayOpen-collapseFive">Endorsements</h3>
          <table className="table table-striped table-bordered accordion-collapse collapse show"  id="panelsStayOpen-collapseFive">
            <thead>
              <tr>
                
              </tr>
            </thead>
            <tbody>
              {/* {endorsements.map((item, index) => ( */}
              <tr>
                <th>Value</th>
                {helpDesk.Endorsements && 
                helpDesk?.Endorsements.slice(0,5).map((endorsement) => ( 
                  <td>{endorsement.EndorsementText}</td>
                ))}
              </tr>
               {/*}))} */}
            </tbody>
          </table>
            <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="true" aria-controls="panelsStayOpen-collapseSix">License Restrictions</h3>
          <table className="table table-striped table-bordered accordion-collapse collapse show"  id="panelsStayOpen-collapseSix">
              <thead>
                <tr>
                  
                </tr>
              </thead>
              <tbody>
                {/* {restrictions.map((item, index) => ( */}
                <tr>
                  <th>Restriction</th>
                  {helpDesk.Restrictions &&
                  helpDesk?.Restrictions.slice(0,5).map((restriction) => (
                    <td>{restriction.RestrictionText}</td>
                  ))}
                </tr>
                {/* ))} */}
              </tbody>
          </table>
            {/* <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="true" aria-controls="panelsStayOpen-collapseSeven">History Comments for Delete of Convictions and Withdrawals</h3>
          <table className="table table-striped table-bordered accordion-collapse collapse show"  id="panelsStayOpen-collapseSeven">
              <thead>
                <tr>
                  <th>Comment</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                </tr>
            </tbody>
          </table> */}
        </>}
        <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseEight" aria-expanded="true" aria-controls="panelsStayOpen-collapseEight">Convictions</h3>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} disabled={!showButtons}
        //onClick={() => navigate('/addconviction')}
        onClick={(e)=> handlAddConvictions(e, tableData)}
        >
          Add Convictions</button>
        <button
            type="button"
            className="btn btn-primary"
            id="button"
            form="Index-form"
            style={{ textAlign: "start" }}
            onClick={() => handleDeleteClick('Conviction(s)')}
            disabled={showButtons === false}
        >
            Delete/Negate Conviction
        </button>
        {source === 'HelpDesk' &&
        <button
            type="button"
            className="btn btn-primary"
            id="button"
            form="Index-form"
            style={{ textAlign: "start" }}
            onClick={() => checkSelection('updateConviction')}
            disabled={showButtons === false}
        >
            Update Conviction
        </button>}
        <div className="table-responsive">
        <table className="table table-striped table-bordered table-sm accordion-collapse collapse show"  id="panelsStayOpen-collapseEight" style={{fontSize: gridFont}}>
        <thead style={{width: '100%'}}>
            <tr>
                <th scope="col">Select</th>
                <th scope="col">Citation Date</th>
                <th scope="col">Conv Date</th>
                <th scope="col">Conv ID</th>
                <th scope="col">SOC</th>
                <th scope="col">Court Type</th>
                <th scope="col">ACD</th>
                <th scope="col">Detail</th>
                <th scope="col">CDL</th>
                <th scope="col">CMV</th>
                <th scope="col">Haz Mat</th>
                <th scope="col">Conv Offense Loc</th>
                <th scope="col">State Native Code</th>
                <th scope="col">Category</th>
                <th scope="col">User ID</th>
                <th scope="col">Date Posted</th>
            </tr>
        </thead>
        <tbody>
          {defaultConvictions.map(conviction => (
            <tr key={conviction.ConvictionIdCode}>
            {selectedConvictions.length <= 15 && (conviction.JurisdictionCodeConvicting === userState || source === 'HelpDesk') ? <td><input type="checkbox" aria-label="Checkbox for following text input" checked={selectedConvictions.includes(conviction.ConvictionIdCode)} 
              onChange={e => {
                if(e.target.checked){
                  setSelectedConvictions([...selectedConvictions, conviction.ConvictionIdCode]);
                } else {
                  setSelectedConvictions(selectedConvictions.filter(id => id !== conviction.ConvictionIdCode));
                }
              }}/></td> :
            <td><input type="checkbox" aria-label="Checkbox for following text input" disabled/></td>}

            <td id="cCitationDate">{conviction.CitationDate}</td>
            <td id="cConvDate">{conviction.ConvictionDate}</td>
            <td id="convID">{conviction.ConvictionIdCode}</td>
            <td id="SOC">{conviction.JurisdictionCodeConvicting}</td>
            {conviction.ConvictionCourtType !== "" && conviction.ConvictionCourtType.split('-')[1] ? <td id="cCourt">{conviction.ConvictionCourtType.split('-')[1]}</td> : <td id="cCourt">{conviction.ConvictionCourtType}</td>}
            <td id="cACD">{conviction?.ConvictionOffenseAcdCode?.Code} - 
              {conviction?.ConvictionOffenseAcdCode?.Description}
            </td>
            <td id="cDetail">{conviction.ConvictionOffenseDetailAcd}</td>
            {conviction.CitationCdlHolderIndicator !== "" && conviction.CitationCdlHolderIndicator.split('-')[1] ? <td id="cCDL">{conviction.CitationCdlHolderIndicator.split('-')[1]}</td> : <td id="cCDL">{conviction.CitationCdlHolderIndicator}</td>}
            {conviction.ConvictionCommercialVehInd !== "" && conviction.ConvictionCommercialVehInd.split('-')[1] ? <td id="CMV">{conviction.ConvictionCommercialVehInd.split('-')[1]}</td> : <td id="CMV">{conviction.ConvictionCommercialVehInd}</td>}
            {conviction.ConvictionHazmatInd !== "" && conviction.ConvictionHazmatInd.split('-')[1] ? <td id="cHazmat">{conviction.ConvictionHazmatInd.split('-')[1]}</td> : <td id="cHazmat">{conviction.ConvictionHazmatInd}</td>}
            <td id="cConvOff">{conviction.ConvictionJurisCourtReportId}</td>
            <td id="cStateNative">{conviction.ConvictionJurisdictionOffenseCode}</td>
            <td id="cCategory">{conviction.ConvictionCategory}</td>
            <td id="cUserID">{conviction.ConvictionUserID}</td>
            <td id="cDatePosted">{conviction.ConvictionDatePosted}</td>
            </tr>
            ))}
            

        </tbody>
        </table>
        </div>
        <h3 className="accordion-button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseNine" aria-expanded="true" aria-controls="panelsStayOpen-collapseNine">Withdrawals</h3>
        <button type="button" className="btn btn-primary" 
            onClick={(e) => handleAddWithdrawal(e)}
            // onClick={() => navigate('/addwithdrawal')}
            disabled={showButtons === false}
            id="button" name="/addwithdrawal" form='Index-form' style={{"textAlign": "start"}}>
              Add Withdrawal
        </button>
        {source === 'HelpDesk' &&
        <><button type="button" className="btn btn-primary"
                onClick={(e) => handleAddWithdrawal(e)}
                // onClick={() => navigate('/staging/addwithdrawal')}
                disabled={showButtons === false}
                id="button" name="/staging/addwithdrawal" form='Index-form' style={{ "textAlign": "start" }}>
                Add Staging Withdrawal
              </button><button type="button" className="btn btn-primary"
                onClick={() => checkSelection('updateStageWithdrawal')}
                disabled={
                  showButtons === false || 
                  selectedWithdrawals.length > 0
                }
                id="button" form='Index-form' style={{ "textAlign": "start" }}>
                  Update Staging Withdrawal
                </button></>}
        <button
            type="button"
            className="btn btn-primary"
            id="button"
            form="Index-form"
            style={{ textAlign: "start" }}
            onClick={() => handleDeleteClick('Withdrawal(s)')}
            disabled={
              showButtons === false || selectedStageWithdrawals.length > 0
            }
        >
            Delete/Negate Withdrawal
        </button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} onClick={() => checkSelection('updateWithdrawal')}
        disabled={
          showButtons === false || selectedStageWithdrawals.length > 0
        }>Update Withdrawal</button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} onClick={() => checkSelection('linkConvictions')} disabled={showButtons === false || selectedStageWithdrawals.length > 0}>Link Convictions</button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} onClick={() => checkSelection('removeAllLinks')} disabled={showButtons === false || selectedStageWithdrawals.length > 0}>Remove All Links From Withdrawal</button>
        <div className="table-responsive">
        <table className="table table-striped table-bordered table-sm accordion-collapse collapse show"  id="panelsStayOpen-collapseNine" style={{fontSize: gridFont}}>
        <thead style={{width: '100%'}}>
          {source === 'HelpDesk' ?
          <tr>
                <th scope="col">Select</th>
                <th scope="col">Effective Date</th>
                <th scope="col">Elig Date</th>
                <th scope="col">Reinstate Date</th>
                <th scope="col">SOW</th>
                <th scope="col">WDraw ID</th>
                <th scope="col">Linkage</th>
                <th scope="col">ACD Code</th>
                <th scope="col">Action</th>
                <th scope="col">Manual/ Electronic</th>
                <th scope="col">Basis</th>
                <th scope="col">Extent</th>
                <th scope="col">WD Locator Ref</th>
                <th scope="col">Reason Ref Code</th>
                <th scope="col">Due Proc Status</th>
                <th scope="col">User ID</th>
                <th scope="col">Notice Period</th>
                <th scope="col">Duration</th>
                <th scope="col">Needs Reins Letter</th>
                <th scope="col">Reins Letter Sent</th>
                <th scope="col">Needs Disq Letter</th>
                <th scope="col">Disq Letter Sent</th>
                <th scope="col">Category</th>
                <th scope="col">Withdrawal Received</th>
                <th scope="col">Withdrawal Posted</th>
                <th scope="col">DQ Mailed Date</th>
            </tr>
          :
            <tr>
                <th scope="col">Select</th>
                <th scope="col">Effective Date</th>
                <th scope="col">Eligibility Date</th>
                <th scope="col">Reinstatement Date</th>
                <th scope="col">SOW</th>
                <th scope="col">Withdrawal ID</th>
                <th scope="col">Link</th>
                <th scope="col">ACD Code</th>
                <th scope="col">Action</th>
                <th scope="col">Basis</th>
                <th scope="col">Extent</th>
                <th scope="col">Due Process Status</th>
                <th scope="col">WD Locator Number</th>
                <th scope="col">State Native Code</th>
                <th scope="col">User ID</th>
                <th scope="col">Date Posted</th>
            </tr>
          }
        </thead>
        <tbody>
          {stagedWithdrawals.map(withdrawal => (
            <tr key={withdrawal.DriverLicenseWithdrawalIdCode}>
                
            {source === 'HelpDesk' ? <td><input type="checkbox" aria-label="Checkbox for following text input" checked={selectedStageWithdrawals.includes(withdrawal.DriverLicenseWithdrawalIdCode)} 
              onChange={e => {
                if(e.target.checked){
                  setSelectedStageWithdrawals([...selectedStageWithdrawals, withdrawal.DriverLicenseWithdrawalIdCode]);
                } else {
                  setSelectedStageWithdrawals(selectedStageWithdrawals.filter(id => id !== withdrawal.DriverLicenseWithdrawalIdCode));
                }
              }}/></td> :
            <td><input type="checkbox" aria-label="Checkbox for following text input" disabled/></td>}
            <td id="wEffectiveDate">{withdrawal.DriverLicenseWithdrawalEffectiveDate}</td>
            <td id="wEligibilityDate">{withdrawal.DRVLicWithdrawalEligibilityDate}</td>
            <td id="wReinstatementDate">{withdrawal.DLWithdrawalReinstatementDate}</td>
            <td id="SOW">{withdrawal.JurisdictionCodeWithdrawing}</td>
            <td id="wID">{withdrawal.DriverLicenseWithdrawalIdCode}</td>
            <td id="wLink">{withdrawal.DLWithdrawalIdConvictionLinksGroup}</td>
            <td id="wACDCode">{withdrawal?.DRVLicAcdWithdrawalReasonCode?.Code} -
              {withdrawal?.DRVLicAcdWithdrawalReasonCode?.Description}
            </td>
            {withdrawal.DriverLicenseWithdrawalType !== "" && withdrawal.DriverLicenseWithdrawalType.split('-')[1] ? <td id="wAction">{withdrawal.DriverLicenseWithdrawalType.split('-')[1]} </td> : <td id="wAction">{withdrawal.DriverLicenseWithdrawalType}</td>}
            <td id="wManElec">{withdrawal.ManualElectronicIndicator}</td>
            {withdrawal.DriverLicenseWithdrawalBasis !== "" && withdrawal.DriverLicenseWithdrawalBasis.split('-')[1] ? <td id="wBasis">{withdrawal.DriverLicenseWithdrawalBasis.split('-')[1]} </td> : <td id="wBasis">{withdrawal.DriverLicenseWithdrawalBasis}</td>}
            {withdrawal.DRVLicWithdrawalExtentIdDlc !== "" && withdrawal.DRVLicWithdrawalExtentIdDlc.split('-')[1] ? <td id="wExtent">{withdrawal.DRVLicWithdrawalExtentIdDlc.split('-')[1]} </td> : <td id="wExtent">{withdrawal.DRVLicWithdrawalExtentIdDlc}</td>}
            <td id="wDLocator">{withdrawal.DLWithdrawalJurisdictionReportId}</td>
            <td id="wReasonRef">{withdrawal.DRVLicWithdrawalReasonReference}</td>
            {withdrawal.DLWithdrawalDueProcessStatus !== "" && withdrawal.DLWithdrawalDueProcessStatus.split('-')[1] ? <td id="wDueProcess">{withdrawal.DLWithdrawalDueProcessStatus.split('-')[1]} </td> : <td id="wDueProcess">{withdrawal.DLWithdrawalDueProcessStatus}</td>}
            <td id="wUserID">{withdrawal.WithdrawalUserId}</td>
            <td id="wNotice">{withdrawal.WithdrawalNoticePeriod}</td>
            <td id="wDuration">{withdrawal.WithdrawalDuration}</td>
            <td id="wReinsLetter"></td>
            <td id="wReinsLetterSent">{withdrawal.WithdrawalReinsLetterSentDate}</td>
            <td id="wDisqLetter">{withdrawal.WithdrawalDisqLetterNeeded}</td>
            <td id="wDisqLetterSent">{withdrawal.WithdrawalDisqLetterSentDate}</td>
            <td id="wCategory">{withdrawal.WithdrawalCategory}</td>
            <td id="wDateReceived">{withdrawal.WithdrawalDateReceived}</td>
            <td id="wDatePosted">{withdrawal.WithdrawalDatePosted}</td>
            <td id="wDQMailDate">{withdrawal.WithdrawalDQLetterMailedDate}</td>
            </tr>
          ))}
          {defaultWithdrawals.map(withdrawal => (
            <tr key={withdrawal.DriverLicenseWithdrawalIdCode}>
                
            {withdrawal.JurisdictionCodeWithdrawing === userState || source === 'HelpDesk' ? <td><input type="checkbox" aria-label="Checkbox for following text input" checked={selectedWithdrawals.includes(withdrawal.DriverLicenseWithdrawalIdCode)} 
              onChange={e => {
                if(e.target.checked){
                  setSelectedWithdrawals([...selectedWithdrawals, withdrawal.DriverLicenseWithdrawalIdCode]);
                } else {
                  setSelectedWithdrawals(selectedWithdrawals.filter(id => id !== withdrawal.DriverLicenseWithdrawalIdCode));
                }
              }}/></td> :
            <td><input type="checkbox" aria-label="Checkbox for following text input" disabled/></td>}
            {source === 'HelpDesk' ?
            <>
            <td id="wEffectiveDate">{withdrawal.DriverLicenseWithdrawalEffectiveDate}</td>
            <td id="wEligibilityDate">{withdrawal.DRVLicWithdrawalEligibilityDate}</td>
            <td id="wReinstatementDate">{withdrawal.DLWithdrawalReinstatementDate}</td>
            <td id="SOW">{withdrawal.JurisdictionCodeWithdrawing}</td>
            <td id="wID">{withdrawal.DriverLicenseWithdrawalIdCode} </td>
            <td id="wLink">{withdrawal.DLWithdrawalIdConvictionLinksGroup}</td>
            <td id="wACDCode">{withdrawal?.DRVLicAcdWithdrawalReasonCode?.Code} -
             {withdrawal?.DRVLicAcdWithdrawalReasonCode?.Description}</td>
            {withdrawal.DriverLicenseWithdrawalType !== "" && withdrawal.DriverLicenseWithdrawalType.split('-')[1] ? <td id="wAction">{withdrawal.DriverLicenseWithdrawalType.split('-')[1]} </td> : <td id="wAction">{withdrawal.DriverLicenseWithdrawalType}</td>}
            <td id="wManElec">{withdrawal.ManualElectronicIndicator}</td>
            {withdrawal.DriverLicenseWithdrawalBasis !== "" && withdrawal.DriverLicenseWithdrawalBasis.split('-')[1] ? <td id="wBasis">{withdrawal.DriverLicenseWithdrawalBasis.split('-')[1]} </td> : <td id="wBasis">{withdrawal.DriverLicenseWithdrawalBasis}</td>}
            {withdrawal.DRVLicWithdrawalExtentIdDlc !== "" && withdrawal.DRVLicWithdrawalExtentIdDlc.split('-')[1] ? <td id="wExtent">{withdrawal.DRVLicWithdrawalExtentIdDlc.split('-')[1]} </td> : <td id="wExtent">{withdrawal.DRVLicWithdrawalExtentIdDlc}</td>}
            <td id="wDLocator">{withdrawal.DLWithdrawalJurisdictionReportId}</td>
            <td id="wReasonRef">{withdrawal.DRVLicWithdrawalReasonReference}</td>
            {withdrawal.DLWithdrawalDueProcessStatus !== "" && withdrawal.DLWithdrawalDueProcessStatus.split('-')[1] ? <td id="wDueProcess">{withdrawal.DLWithdrawalDueProcessStatus.split('-')[1]} </td> : <td id="wDueProcess">{withdrawal.DLWithdrawalDueProcessStatus}</td>}
            <td id="wUserID">{withdrawal.WithdrawalUserId}</td>
            <td id="wNotice">{withdrawal.WithdrawalNoticePeriod}</td>
            <td id="wDuration">{withdrawal.WithdrawalDuration}</td>
            <td id="wReinsLetter"></td>
            <td id="wReinsLetterSent">{withdrawal.WithdrawalReinsLetterSentDate}</td>
            <td id="wDisqLetter">{withdrawal.WithdrawalDisqLetterNeeded}</td>
            <td id="wDisqLetterSent">{withdrawal.WithdrawalDisqLetterSentDate}</td>
            <td id="wCategory">{withdrawal.WithdrawalCategory}</td>
            <td id="wDateReceived">{withdrawal.WithdrawalDateReceived}</td>
            <td id="wDatePosted">{withdrawal.WithdrawalDatePosted}</td>
            <td id="wDQMailDate">{withdrawal.WithdrawalDQLetterMailedDate}</td>
            </>:
            <>
            <td id="wEffectiveDate">{withdrawal.DriverLicenseWithdrawalEffectiveDate}</td>
            <td id="wEligibilityDate">{withdrawal.DRVLicWithdrawalEligibilityDate}</td>
            <td id="wReinstatementDate">{withdrawal.DLWithdrawalReinstatementDate}</td>
            <td id="SOW">{withdrawal.JurisdictionCodeWithdrawing}</td>
            <td id="wID">{withdrawal.DriverLicenseWithdrawalIdCode}</td>
            <td id="wLink">{withdrawal.DLWithdrawalIdConvictionLinksGroup}</td>
            <td id="wACDCode">{withdrawal?.DRVLicAcdWithdrawalReasonCode?.Code} -
              {withdrawal?.DRVLicAcdWithdrawalReasonCode?.Description} 
            </td>
            {withdrawal.DriverLicenseWithdrawalType !== "" && withdrawal.DriverLicenseWithdrawalType.split('-')[1] ? <td id="wAction">{withdrawal.DriverLicenseWithdrawalType.split('-')[1]} </td> : <td id="wAction">{withdrawal.DriverLicenseWithdrawalType}</td>}
            {withdrawal.DriverLicenseWithdrawalBasis !== "" && withdrawal.DriverLicenseWithdrawalBasis.split('-')[1] ? <td id="wBasis">{withdrawal.DriverLicenseWithdrawalBasis.split('-')[1]} </td> : <td id="wBasis">{withdrawal.DriverLicenseWithdrawalBasis}</td>}
            {withdrawal.DRVLicWithdrawalExtentIdDlc !== "" && withdrawal.DRVLicWithdrawalExtentIdDlc.split('-')[1] ? <td id="wExtent">{withdrawal.DRVLicWithdrawalExtentIdDlc.split('-')[1]} </td> : <td id="wExtent">{withdrawal.DRVLicWithdrawalExtentIdDlc}</td>}
            {withdrawal.DLWithdrawalDueProcessStatus !== "" && withdrawal.DLWithdrawalDueProcessStatus.split('-')[1] ? <td id="wDueProcess">{withdrawal.DLWithdrawalDueProcessStatus.split('-')[1]} </td> : <td id="wDueProcess">{withdrawal.DLWithdrawalDueProcessStatus}</td>}
            <td id="wDLocator">{withdrawal.DLWithdrawalJurisdictionReportId}</td>
            <td id="wStateNative">{withdrawal.DRVLicWithdrawalReasonReference}</td>
            <td id="wUserID">{withdrawal.WithdrawalUserId}</td>
            <td id="wDatePosted">{withdrawal.WithdrawalDatePosted}</td>
            </>
            }
            </tr>
          ))}

        </tbody>
        </table>
        </div>
        </div>
        </div>
        </div>
        {/* Bootstrap Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form onSubmit={(e) => handleModalSubmit(e)}>
              <div className="modal-header">
                <h5 className="modal-title">Comments for Negate/Delete of {deleteType}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>
              <div className="modal-body">
                  <div class="form-group">
                   <span style={{color:'red'}}>{requestIssue}</span>
                    <label for="message-text" class="col-form-label">Reason for Negate/Delete</label>
                    {(source !== 'HelpDesk' && userState in negateDropDown) ?
                    <select class="form-select" aria-label="Default select example"
                      value={inputValue}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled selected>Select your option</option>
                      {negateDropDown[userState].map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select> :
                    <input
                      type="text"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder="Reason"
                      style={{ width: "100%", marginBottom: 12 }}
                      required
                    />}
                  </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-danger"
                >
                  Delete
                </button>
              </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Bootstrap Modal */}
      {showReviewModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowReviewModal(false)}
                />
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete the review(s)
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowReviewModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleReviewComplete()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {displayError && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Error</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDisplayError(false)}
                />
              </div>
              <div className="modal-body">
                <p>
                  {errorMessage}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );

}

function buildStatusRequest(userID, jurisdiction, country, license, lastname, firstname, dob, result ) {
  console.log("DOB in buildStatusRequest:", dob);
  const baseData = {
        Header: { Metadata: { UserID: userID } },
        Body: {
          DriverRequest: {
            DriverLicense: {
              LicenseCountry: country,
              LicenseState: jurisdiction,
              LicenseNumber: license,
            },
          },
        },
      };
      // if(result.License?.LicenseNumber === null){
      //   console.log("Driver not found")
      //   return;
      // }
      if(country === "CA"){
        // if(lastname && firstname && dob){
        //   if( result.PersonDetails?.PersonName?.SurName.toLowerCase() !== lastname?.toLowerCase()
        //     || result.PersonDetails?.PersonName?.FirstName?.toLowerCase() !== firstname?.toLowerCase()
        //     || result.PersonDetails?.DOB !== dob){
        //       console.log("Name or DOB mismatch")
        //       return;
        //   } 
        // }
          return{
            ...baseData,
            Body: {
              ...baseData.Body,
              DriverRequest: {
                ...baseData.Body.DriverRequest,
                DriverData: {
              DriverName: {
                DriverFirstName: (firstname || result.PersonDetails?.PersonName?.FirstName)?.trim(),
                DriverMiddleName: result.PersonDetails?.PersonName?.MiddleName?.trim(),
                DriverLastName: (lastname || result.PersonDetails?.PersonName?.SurName)?.trim(),
              },
              DriverDOB: dob ? moment(dob).format("YYYY-MM-DD") : moment(result.PersonDetails.DOB).format("YYYY-MM-DD"),
            }
              },
            },
          }
        }
      return baseData;
}
export default DriverDetails;